import { createSelector } from 'reselect';
import { IEntityUsageState } from 'redux/reducers/usage/entityUsage';
import { IFilterState } from 'redux/reducers/usage/filter/filter';

const getApiState = (state: IEntityUsageState | IFilterState): any => {
  return {
    pending: state.pending,
    fulfilled: state.fulfilled,
    rejected: state.rejected,
  };
};

type ApiStatus =
  | 'unknown'
  | 'unloaded'
  | 'loading'
  | 'ready'
  | 'errored'
  | 'updating';

/**
 * This redux selector takes redux state as argument and returns the different status keys
 * combined into a more human understandable status. This way, we differentiate between
 * storing the technical status code in redux and derived/computed values which we might need in the component.
 */
const computeApiState = createSelector(
  [getApiState],
  (apiState: any): ApiStatus => {
    const { pending, fulfilled, rejected } = apiState;

    let apiStatus: ApiStatus = 'unknown';
    if (!pending && !fulfilled && !rejected) {
      apiStatus = 'unloaded';
    } else if (pending && !fulfilled && !rejected) {
      apiStatus = 'loading';
    } else if (!pending && fulfilled && !rejected) {
      apiStatus = 'ready';
    } else if (!pending && rejected) {
      apiStatus = 'errored';
    } else if (pending && fulfilled && !rejected) {
      apiStatus = 'updating';
    }
    return apiStatus;
  }
);

export default computeApiState;
